/* eslint-disable react/prop-types */
import React from "react";
import { Box, Grid } from "@mui/material";
import moment from "moment";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { differenceInYears } from "date-fns";
import Typography from "../common/new/Typography/Typography";
import styles from "./MemberInfo.styles";
import { selectAllSIUsers } from "../../redux/selectors/user";
import gohonzonBackground from "../../assets/images/gohonzonBackground.png";
import Button from "../common/Button";
// import gohonzonTitle from "../../assets/svg/gohonzonTitle.svg";

function MemberInfo({
  title1,
  title2,
  memberDetails,
  heading,
  memberInfo,
  onOpenTrackingModal,
}) {
  const {
    memberId,
    fullName,
    addressLine1,
    mobileNumber,
    pincode,
    areaName,
    clusterName,
    regionName,
    districtName,
    zoneName,
    chapterName,
    dateOfBirth,
    blockName,
    divisionName,
    stateName,
    cityName,
  } = !memberDetails ? "" : memberDetails;
  const { appliedBy, appliedAt } = memberInfo;
  const { type } = useParams();

  const date = moment();
  // const currentDate = date.format("D/MM/YYYY");
  const newAppliedDate = moment(appliedAt).format(" DD/MM/YYYY");

  const formattedCurrentDate = date.format("YYYY-MM-DD");

  const currentFormattedDate = new Date(formattedCurrentDate);
  const birthDate = new Date(dateOfBirth);

  const age = differenceInYears(currentFormattedDate, birthDate);

  const {
    isDistrictSi,
    isRegionSi,
    isZoneSi,
    isHelpDesk,
    isChapterSi,
    isHelpDeskAdmin,
  } = useSelector(selectAllSIUsers);
  const isReturn = type === "return";
  const isInterviewRegionSi = type === `interview`;
  const isReturnZoneSi = isZoneSi && type === "return";

  return (
    <>
      <Box paddingBottom="16px">
        <Box
          style={{
            backgroundImage: `url(${gohonzonBackground})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            marginBottom: "10px",
            padding: "22px 30px 10px 30px",
          }}
        >
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="title1"
              style={{
                color: "#FFF",
                fontFeatureSettings: "'clig' off, 'liga' off",
                fontFamily: "Noto Sans",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "20px",
                padding: "11px 18px 13px 17px",
              }}
            >
              {heading}
            </Typography>
            <Typography variant="mini" weight={500} color="#F5F5F5" mr="16px">
              {isDistrictSi || (isRegionSi && isReturn) ? (
                <div style={{ textAlign: "center", paddingTop: "10px" }}>
                  DATE OF APPLYING: {newAppliedDate}
                </div>
              ) : (
                <div>
                  INITIATED DATE:
                  {appliedAt !== null
                    ? moment(appliedAt).format(" DD/MM/YYYY")
                    : " NA"}
                </div>
              )}
              {(!isDistrictSi && isInterviewRegionSi) ||
              isHelpDesk ||
              isHelpDeskAdmin ||
              isReturnZoneSi ||
              isChapterSi ? (
                <div>
                  INITIATED BY: {appliedBy !== null ? appliedBy : " NA"}{" "}
                </div>
              ) : null}
            </Typography>
          </Box>
        </Box>
        {(type === "tracking" || type === "tracking-return") && (
          <Box py="16px">
            <Box
              style={{
                borderRadius: "35px",
                background: "#196AAB",
                width: "190px",
                height: "44px",
                flexShrink: "0",
                marginBottom: "-20px",
                position: "relative",
                zIndex: "1",
                marginLeft: "45px",
              }}
            >
              <Typography
                variant="title3"
                style={{
                  color: "#FFF",
                  fontFeatureSettings: "'clig' off, 'liga' off",
                  fontFamily: "Noto Sans",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: "600",
                  lineHeight: "20px",
                  padding: "11px 18px 13px 17px",
                  margin: "0",
                }}
              >
                Gohonzon Status
              </Typography>
            </Box>
            <Box
              style={{
                borderRadius: "5px 5px 5px 5px",
                border: "1px solid #C2D4EB",
                background: "#F6F6F6",
                padding: "30px 10px 20px 20px",
                borderBottom: "9px solid #196AAB",
                margin: "0px 20px",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space around",
                }}
              >
                <Box sx={{ margin: "16px 24px 16px 24px" }}>
                  <Button label="Tracking" onClick={onOpenTrackingModal} />
                </Box>
              </Box>
            </Box>
          </Box>
        )}
        <Box
          style={{
            borderRadius: "35px",
            background: "#196AAB",
            width: "158px",
            height: "44px",
            flexShrink: "0",
            marginBottom: "-20px",
            position: "relative",
            zIndex: "1",
            marginLeft: "45px",
          }}
        >
          <Typography
            variant="title3"
            style={{
              color: "#FFF",
              fontFeatureSettings: "'clig' off, 'liga' off",
              fontFamily: "Noto Sans",
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: "600",
              lineHeight: "20px",
              padding: "11px 18px 13px 17px",
              margin: "0",
            }}
          >
            {title1}
          </Typography>
        </Box>
        <Box
          style={{
            borderRadius: "5px 5px 5px 5px",
            border: "1px solid #C2D4EB",
            background: "#F6F6F6",
            padding: "10px 0px 0px 0px",
            borderBottom: "9px solid #196AAB",
            margin: "0px 20px",
          }}
        >
          <Grid container>
            <Grid item xs={12}>
              <Grid container>
                <Box style={{ ...styles.paiarStyles, background: "#F6F6F6" }}>
                  <Box
                    style={{
                      ...styles.keyStyle,
                      padding: "5px",
                    }}
                  />
                </Box>

                <Box style={{ ...styles.paiarStyles2 }}>
                  <Box
                    style={{
                      ...styles.paiarStyles,
                      padding: "10px",
                    }}
                  >
                    <Box
                      style={{
                        ...styles.keyStyle,
                      }}
                    >
                      MEMBER ID :
                    </Box>
                    <Box style={styles.valueStyle}>{memberId}</Box>
                  </Box>
                  <Box
                    style={{
                      ...styles.paiarStyles,
                      padding: "10px",
                    }}
                  >
                    <Box
                      style={{
                        ...styles.keyStyle,
                      }}
                    >
                      MEMBER NAME :
                    </Box>
                    <Box style={styles.valueStyle}>{fullName}</Box>
                  </Box>
                </Box>

                <Box style={{ ...styles.paiarStyles }}>
                  <Box
                    style={{
                      ...styles.paiarStyles,
                      padding: "10px",
                    }}
                  >
                    <Box
                      style={{
                        ...styles.keyStyle,
                      }}
                    >
                      Date of Birth :
                    </Box>
                    <Box style={styles.valueStyle}>{dateOfBirth || "NA"}</Box>
                  </Box>
                  <Box
                    style={{
                      ...styles.paiarStyles,
                      padding: "10px",
                    }}
                  >
                    <Box
                      style={{
                        ...styles.keyStyle,
                      }}
                    >
                      Contact Number :
                    </Box>
                    <Box style={styles.valueStyle}>{mobileNumber || "NA"}</Box>
                  </Box>
                </Box>

                <Box style={{ ...styles.paiarStyles2 }}>
                  <Box
                    style={{
                      ...styles.paiarStyles,
                      padding: "10px",
                    }}
                  >
                    <Box
                      style={{
                        ...styles.keyStyle,
                      }}
                    >
                      Age :
                    </Box>
                    <Box style={styles.valueStyle}>
                      {dateOfBirth !== null ? age : "NA"}
                    </Box>
                  </Box>
                  <Box
                    style={{
                      ...styles.paiarStyles,
                      padding: "10px",
                    }}
                  >
                    <Box
                      style={{
                        ...styles.keyStyle,
                      }}
                    >
                      Division :
                    </Box>
                    <Box style={styles.valueStyle}>{divisionName || "NA"}</Box>
                  </Box>
                </Box>

                <Box style={{ ...styles.paiarStyles }}>
                  <Box
                    style={{
                      ...styles.paiarStyles,
                      padding: "10px",
                    }}
                  >
                    <Box
                      style={{
                        ...styles.keyStyle,
                      }}
                    >
                      ADDRESS :
                    </Box>
                    <Box style={styles.valueStyle}>{addressLine1}</Box>
                  </Box>
                  <Box
                    style={{
                      ...styles.paiarStyles,
                      padding: "10px",
                    }}
                  >
                    <Box
                      style={{
                        ...styles.keyStyle,
                      }}
                    >
                      PINCODE :
                    </Box>
                    <Box style={styles.valueStyle}>{pincode || "NA"}</Box>
                  </Box>
                </Box>

                <Box style={{ ...styles.paiarStyles2 }}>
                  <Box
                    style={{
                      ...styles.paiarStyles,
                      padding: "10px",
                    }}
                  >
                    <Box
                      style={{
                        ...styles.keyStyle,
                      }}
                    >
                      STATE :
                    </Box>
                    <Box style={styles.valueStyle}>{stateName || "NA"}</Box>
                  </Box>
                  <Box
                    style={{
                      ...styles.paiarStyles,
                      padding: "10px",
                    }}
                  >
                    <Box
                      style={{
                        ...styles.keyStyle,
                      }}
                    >
                      CITY :
                    </Box>
                    <Box style={styles.valueStyle}>{cityName || "NA"}</Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box py="16px">
        <Box
          style={{
            borderRadius: "35px",
            background: "#196AAB",
            width: "205px",
            height: "44px",
            flexShrink: "0",
            marginBottom: "-20px",
            position: "relative",
            zIndex: "1",
            marginLeft: "45px",
          }}
        >
          <Typography
            variant="title3"
            style={{
              color: "#FFF",
              fontFeatureSettings: "'clig' off, 'liga' off",
              fontFamily: "Noto Sans",
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: "600",
              lineHeight: "20px",
              padding: "11px 18px 13px 17px",
              margin: "0",
            }}
          >
            {title2}
          </Typography>
        </Box>
        <Box
          style={{
            borderRadius: "5px 5px 5px 5px",
            border: "1px solid #C2D4EB",
            background: "#F6F6F6",
            padding: "20px 0px 0px 0px",
            borderBottom: "9px solid #196AAB",
            margin: "0px 20px",
          }}
        >
          <Grid container>
            <Grid item xs={12}>
              <Grid container>
                <Box style={{ ...styles.paiarStyles3, background: "#F6F6F6" }}>
                  <Box
                    style={{
                      ...styles.keyStyle,
                      padding: "5px",
                    }}
                  />
                </Box>

                <Box style={{ ...styles.paiarStyles4 }}>
                  <Box
                    style={{
                      ...styles.paiarStyles,
                    }}
                  >
                    <Box
                      style={{
                        ...styles.keyStyle,
                        padding: "10px",
                      }}
                    >
                      Area :
                    </Box>
                    <Box style={styles.valueStyle}>{areaName || "NA"}</Box>
                  </Box>
                  <Box
                    style={{
                      ...styles.paiarStyles,
                    }}
                  >
                    <Box
                      style={{
                        ...styles.keyStyle,
                        padding: "10px",
                      }}
                    >
                      Cluster :
                    </Box>
                    <Box style={styles.valueStyle}>{clusterName || "NA"}</Box>
                  </Box>
                  <Box
                    style={{
                      ...styles.paiarStyles,
                    }}
                  >
                    <Box
                      style={{
                        ...styles.keyStyle,
                        padding: "10px",
                      }}
                    >
                      Zone :
                    </Box>
                    <Box style={styles.valueStyle}>{zoneName || "NA"}</Box>
                  </Box>
                </Box>

                <Box style={{ ...styles.paiarStyles3 }}>
                  <Box style={styles.paiarStyles}>
                    <Box
                      style={{
                        ...styles.keyStyle,
                        padding: "10px",
                      }}
                    >
                      Region :
                    </Box>
                    <Box style={styles.valueStyle}>{regionName || "NA"}</Box>
                  </Box>
                  <Box style={styles.paiarStyles}>
                    <Box
                      style={{
                        ...styles.keyStyle,
                        padding: "10px",
                      }}
                    >
                      chapter :
                    </Box>
                    <Box style={styles.valueStyle}>{chapterName || "NA"}</Box>
                  </Box>
                </Box>

                <Box style={{ ...styles.paiarStyles4 }}>
                  <Box
                    style={{
                      ...styles.paiarStyles,
                    }}
                  >
                    <Box
                      style={{
                        ...styles.keyStyle,
                        padding: "10px",
                      }}
                    >
                      district :
                    </Box>
                    <Box style={styles.valueStyle}>{districtName || "NA"}</Box>
                  </Box>
                  <Box
                    style={{
                      ...styles.paiarStyles,
                    }}
                  >
                    <Box
                      style={{
                        ...styles.keyStyle,
                        padding: "10px",
                      }}
                    >
                      block :
                    </Box>
                    <Box style={styles.valueStyle}>{blockName || "NA"}</Box>
                  </Box>
                </Box>
                {/* </Grid> */}
                {/* </Grid> */}
                {/* </Grid> */}
                {/* <Grid item xs={6}> */}
                {/* <Grid item xs={12}> */}
                {/* <Box style={{ ...styles.paiarStyles, background: "#FFF" }}>
                  <Box
                    style={{
                      ...styles.keyStyle,
                      padding: "5px",
                    }}
                  />
                </Box> */}
                {/* <Box
                  style={{
                    ...styles.paiarStyles,
                    // background: "#ECECEC"
                  }}
                >
                  <Box
                    style={{
                      ...styles.keyStyle,
                      padding: "10px",
                    }}
                  >
                    Zone :
                  </Box>
                  <Box style={styles.valueStyle}>{zoneName || "NA"}</Box>
                </Box> */}
                {/* <Box style={styles.paiarStyles}>
                  <Box
                    style={{
                      ...styles.keyStyle,
                      padding: "10px",
                    }}
                  >
                    chapter :
                  </Box>
                  <Box style={styles.valueStyle}>{chapterName || "NA"}</Box>
                </Box> */}
                {/* <Box
                  style={{
                    ...styles.paiarStyles,
                    // background: "#ECECEC"
                  }}
                >
                  <Box
                    style={{
                      ...styles.keyStyle,
                      padding: "10px",
                    }}
                  >
                    block :
                  </Box>
                  <Box style={styles.valueStyle}>{blockName || "NA"}</Box>
                </Box> */}
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}

export default MemberInfo;
